import {
  SURFACE_COATING_SET_DATA, SURFACE_COATING_IS_FETCHING_DATA,
  SURFACE_COATING_SET_SURFACE_COATING_SERVICE, SURFACE_COATING_SET_PAINTING_SERVICE,
  SURFACE_COATING_SET_POWDER_PAINTING_SERVICE, SURFACE_COATING_SET_GALVANIZING_SERVICE,
  SURFACE_COATING_SET_PAINTING_DATA, SURFACE_COATING_SET_POWDER_PAINTING_DATA,
  SURFACE_COATING_SET_GALVANIZING_DATA
} from "./actionTypes";
import {http, message} from "../utils";
import {API_BASE_URL} from "../constants";
import {forceLogoutUser} from "./authActions";

const fetchSurfaceCoatingData = () => dispatch => {
  dispatch({
    type: SURFACE_COATING_IS_FETCHING_DATA,
    payload: true,
  })

  return http
    .get(`${API_BASE_URL}/surface-coating`)
    .then(response => {
      dispatch({
        type: SURFACE_COATING_SET_DATA,
        payload: response.data,
      })

      dispatch({
        type: SURFACE_COATING_IS_FETCHING_DATA,
        payload: false,
      })
    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        dispatch({
          type: SURFACE_COATING_IS_FETCHING_DATA,
          payload: false,
        })
        message.show(message.type.error, http.getErrorMessage(error))
      }
    })
}

const setSurfaceCoatingService = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_SURFACE_COATING_SERVICE,
    payload: payload.value,
  })

  return http
    .put(`${API_BASE_URL}/surface-coating`, {hasSurfaceCoating: payload.value})
    .then(response => {

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
      }
    })
}

const setSurfaceCoatingPainting = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_PAINTING_SERVICE,
    payload: payload.value,
  })

  return http
    .put(`${API_BASE_URL}/surface-coating/has-painting`, {hasPainting: payload.value})
    .then(response => {

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
      }
    })
}

const setSurfaceCoatingPowderPainting = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_POWDER_PAINTING_SERVICE,
    payload: payload.value,
  })

  return http
    .put(`${API_BASE_URL}/surface-coating/has-powder-painting`, {hasPowderPainting: payload.value})
    .then(response => {

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
      }
    })
}

const setSurfaceCoatingGalvanizing = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_GALVANIZING_SERVICE,
    payload: payload.value,
  })

  return http
    .put(`${API_BASE_URL}/surface-coating/has-galvanizing`, {hasGalvanizing: payload.value})
    .then(response => {

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
      }
    })
}

const setPaintingData = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_PAINTING_DATA,
    payload: payload,
  })
}

const setPowderPaintingData = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_POWDER_PAINTING_DATA,
    payload: payload,
  })
}

const setGalvanizingData = payload => dispatch => {
  dispatch({
    type: SURFACE_COATING_SET_GALVANIZING_DATA,
    payload: payload,
  })
}

export {
  fetchSurfaceCoatingData,
  setSurfaceCoatingService,
  setSurfaceCoatingPainting,
  setSurfaceCoatingPowderPainting,
  setSurfaceCoatingGalvanizing,
  setPaintingData,
  setPowderPaintingData,
  setGalvanizingData
}
